import React from 'react'

export function HeaderMisPedidos({ ...props }) {
    const {
        ruta = '/login',
        type
    } = props

    return (
        <a href={ruta} className="icoPedidos" aria-label="Ir a Mis Pedidos"><span className="textReference">MisPedidos</span></a>
    )
}